'use client'
import { createContext, useContext } from 'react'
import type { PublicTenantConfig } from '@/config/tenants/types'

const TenantContext = createContext<PublicTenantConfig | null>(null)

/**
 * Hydrated once by the root layout from the server-resolved tenant. Carries
 * only the public configuration.
 */
export function TenantProvider({
    tenant,
    children,
}: {
    tenant: PublicTenantConfig
    children: React.ReactNode
}) {
    return <TenantContext.Provider value={tenant}>{children}</TenantContext.Provider>
}

/** Active tenant when rendered inside TenantProvider; null on legacy GM deploys. */
export function useOptionalTenant(): PublicTenantConfig | null {
    return useContext(TenantContext)
}

export function useTenant(): PublicTenantConfig {
    const tenant = useOptionalTenant()

    if (!tenant) {
        throw new Error('useTenant must be used within a TenantProvider')
    }

    return tenant
}